import { DownCircleTwoTone, StopTwoTone } from '@ant-design/icons';
import styles from '../EddingGameCard.module.scss';
import { Button, Form, Modal, Radio, RadioChangeEvent, Tag } from 'antd';
import { Input as CustomInput } from '../../..';
import { useEffect, useState } from 'react';
import cn from 'classnames'

const errorMessage = 'Required field';

interface IAnswers {
  answers: any;
  correctAnswer: string;
  setIsAnswersModalOpen: (value: boolean) => void;
  isAnswersModalOpen: boolean;
  onSaveAnswers: () => void;
  form: any;
  onChangeCorrectAnswer: (e: RadioChangeEvent) => void;
}

const Answers = ({
  answers,
  correctAnswer,
  setIsAnswersModalOpen,
  isAnswersModalOpen,
  onSaveAnswers,
  form,
  onChangeCorrectAnswer,
}: IAnswers) => {
  const [data, setData] = useState({});

  useEffect(() => {
    const newObj = {};

    Object.keys(answers).forEach(lang => {
      Object.keys(answers[lang]).forEach(answerKey => {
        newObj[`${answerKey}_${lang}`] = answers[lang][answerKey];
      });
    });

    setData(newObj);
  }, [answers]);

  return (
    <div className={styles.vaccineCardWrap}>
      <div>Answers (EN/RU):</div>
      <div>
        <div>
          <div className={styles.answers__listWrap}>
            {!!answers.eng.answer1 &&
              Object.keys(answers.eng).map((key, idx) => (
                <div key={idx} className={cn(styles.answerItem, {[styles.answerItem__border]: idx!== 3})}>
                  <div>
                    {(idx + 1).toString() === correctAnswer ? (
                      <DownCircleTwoTone twoToneColor="#7CFC00" />
                    ) : (
                      <StopTwoTone twoToneColor="#FF0000" />
                    )}
                  </div>
                  <div className={styles.answers__list}>
                    <span>
                      <Tag color="#00ADB5">EN:</Tag>
                      {answers.eng[key]}
                    </span>

                    <span>
                      <Tag color="#87d068">RU:</Tag>
                      {answers.ru[key]}
                    </span>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <Button
          style={{ background: '#FFCC70', color: '#000' }}
          onClick={() => setIsAnswersModalOpen(true)}
          block
        >
          {!!Object.keys(answers).length ? 'Edit quiz anwers (EN/RU)' : 'Enter quiz anwers (EN/RU)'}
        </Button>

        <Modal
          title="Enter answers (EN/RU):"
          open={isAnswersModalOpen}
          onOk={onSaveAnswers}
          onCancel={() => setIsAnswersModalOpen(false)}
        >
          <Form name="answers_form" autoComplete="off" form={form} initialValues={data}>
            <Radio.Group
              onChange={onChangeCorrectAnswer}
              value={correctAnswer}
              className={styles.answers}
            >
              <Radio value={'1'}>
                <div className={styles.answer__wrap}>
                  <div className={styles.answer__inner}>
                    <Tag color="#00ADB5">EN:</Tag>
                    <CustomInput
                      name="answer1_eng"
                      placeholder="Enter answer 1"
                      errorMessage={errorMessage}
                      size="middle"
                    />
                  </div>
                  <div className={styles.answer__inner}>
                    <Tag color="#87d068">RU:</Tag>
                    <CustomInput
                      name="answer1_ru"
                      placeholder="Введите ответ 1"
                      errorMessage={errorMessage}
                      size="middle"
                    />
                  </div>
                </div>
              </Radio>
              <Radio value={'2'}>
                <div className={styles.answer__wrap}>
                  <div className={styles.answer__inner}>
                    <Tag color="#00ADB5">EN:</Tag>
                    <CustomInput
                      name="answer2_eng"
                      placeholder="Enter answer 2"
                      errorMessage={errorMessage}
                      size="middle"
                    />
                  </div>
                  <div className={styles.answer__inner}>
                    <Tag color="#87d068">RU:</Tag>
                    <CustomInput
                      name="answer2_ru"
                      placeholder="Введите ответ 2"
                      errorMessage={errorMessage}
                      size="middle"
                    />
                  </div>
                </div>
              </Radio>
              <Radio value={'3'}>
                <div className={styles.answer__wrap}>
                  <div className={styles.answer__inner}>
                    <Tag color="#00ADB5">EN:</Tag>
                    <CustomInput
                      name="answer3_eng"
                      placeholder="Enter answer 3"
                      errorMessage={errorMessage}
                      size="middle"
                    />
                  </div>
                  <div className={styles.answer__inner}>
                    <Tag color="#87d068">RU:</Tag>
                    <CustomInput
                      name="answer3_ru"
                      placeholder="Введите ответ 3"
                      errorMessage={errorMessage}
                      size="middle"
                    />
                  </div>
                </div>
              </Radio>
              <Radio value={'4'}>
                <div className={styles.answer__wrap}>
                  <div className={styles.answer__inner}>
                    <Tag color="#00ADB5">EN:</Tag>
                    <CustomInput
                      name="answer4_eng"
                      placeholder="Enter answer 4"
                      errorMessage={errorMessage}
                      size="middle"
                    />
                  </div>
                  <div className={styles.answer__inner}>
                    <Tag color="#87d068">RU:</Tag>
                    <CustomInput
                      name="answer4_ru"
                      placeholder="Введите ответ 4"
                      errorMessage={errorMessage}
                      size="middle"
                    />
                  </div>
                </div>
              </Radio>
            </Radio.Group>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default Answers;
